export const NOTIFICATION_POLL_INTERVAL_MS = 30_000;
export const INBOX_COUNT_STALE_TIME_MS = 30_000;
